import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { formatPrice } from "@/lib/currency";

export default function Cart() {
  const { items, subtotal, update, remove } = useCart();
  return (
    <div data-testid="cart-page" className="max-w-[1200px] mx-auto px-6 lg:px-12 py-20">
      <div className="overline">Bag</div>
      <h1 className="serif text-5xl mt-3 mb-12">Your selection.</h1>
      {items.length === 0 ? (
        <div className="text-center py-20">
          <p className="serif text-2xl">Your bag is empty.</p>
          <Link to="/shop" className="btn-outline mt-8 inline-flex" data-testid="cart-empty-shop">Discover the shop</Link>
        </div>
      ) : (
        <div className="grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2 space-y-6">
            {items.map((it) => (
              <div key={it.key} className="flex gap-6 border-b border-[#E5E5DF] pb-6">
                <img src={it.image} alt={it.name} className="w-32 h-40 object-cover" />
                <div className="flex-1">
                  <Link to={`/product/${it.product_id}`} className="serif text-2xl">{it.name}</Link>
                  <div className="text-xs text-[#5A5A5A] mt-1">{it.size} · {it.color}</div>
                  <div className="mt-3 text-sm">{formatPrice(it.price)}</div>
                  <div className="mt-6 inline-flex items-center border border-[#E5E5DF]">
                    <button onClick={() => update(it.key, it.quantity - 1)} className="px-3 py-1">−</button>
                    <span className="px-4">{it.quantity}</span>
                    <button onClick={() => update(it.key, it.quantity + 1)} className="px-3 py-1">+</button>
                  </div>
                  <button onClick={() => remove(it.key)} className="ml-4 text-xs underline">Remove</button>
                </div>
              </div>
            ))}
          </div>
          <aside className="bg-[#EFEFE8] p-8 h-fit">
            <div className="overline">Summary</div>
            <div className="flex justify-between mt-6"><span>Subtotal</span><span>{formatPrice(subtotal)}</span></div>
            <div className="flex justify-between mt-2 text-xs text-[#5A5A5A]"><span>Shipping</span><span>{subtotal > 200 ? "Complimentary" : formatPrice(15)}</span></div>
            <div className="flex justify-between mt-6 pt-6 border-t border-[#E5E5DF] serif text-2xl">
              <span>Total</span>
              <span>{formatPrice(subtotal + (subtotal > 200 ? 0 : 15))}</span>
            </div>
            <Link data-testid="cart-checkout-link" to="/checkout" className="btn-primary w-full justify-center mt-8">Checkout</Link>
          </aside>
        </div>
      )}
    </div>
  );
}
